module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0116.jpg?v=23b647f4";